import api from '@anm/api';

type HelperProps = {
  projectId: string;
  mediaType?: 'video' | 'image' | 'audio';
};

const checkIsUploadStable = async ({ projectId, mediaType = 'video' }: HelperProps) => {
  const upload = await api().uploads.getUploadByProjectId(projectId);
  const files = upload.files?.filter(item => item.file.fileType === mediaType);
  const isStable = files?.some(media => media.file.status === 'stable');

  return files.length ? isStable : true;
};

export default checkIsUploadStable;
